import React, { useEffect, useState } from 'react';
import { Link, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Grid, BottomNavigation, BottomNavigationAction, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import logo from '../images/logo2.png';

import { logout } from '../actions/authorizeAction';

const StyledBottomNavigationAction = withStyles(() => ({
  root: {
    marginTop: 15,
    '&$selected': {

      backgroundColor: 'FORESTGREEN',
    },
  },
  label: {
    fontSize: '1.1rem',
    fontWeight: 700,
    '&$selected': {
      fontSize: '1.1rem',
      fontWeight: 400,
      color: 'white',
    },
  },
  selected: {
  },
}))(BottomNavigationAction);

const image = {
  width: '60%',
  WebkitFilter: 'drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.7))',
  filter: 'drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.7))',
};

const MenuBar = (props) => {
  const [navSelected, setNavSelected] = useState(props.path);
  const authorize = useSelector(state => state.authorize);
  const dispatch = useDispatch();

  useEffect(() => {
    setNavSelected(props.path);
  }, [props.path]);

  if (!authorize.user) {
    return (<Redirect to="/login" />);
  }

  const onNavChange = (event, value) => {
    //event.preventDefault();

    if (value === 'logout') {
      sessionStorage.removeItem('loginInfo');
      dispatch(logout());
      document.location.href = "/";
    }
    setNavSelected(value);
  };

  return (
    <>
      <Box display="flex">
        <Box pl={3} display="flex" style={{ backgroundColor: "rgba(245, 245, 245, 0.8)" }}>
          <Box alignSelf="flex-end">
            <img src={logo} style={image} alt="logo" />
          </Box>
        </Box>
        <Grid container>
          <Grid item xs={10}>
          <BottomNavigation showLabels value={navSelected} onChange={onNavChange} style={{ backgroundColor: 'rgba(245, 245, 245, 0.8)'}}>
            <StyledBottomNavigationAction component={Link} to="/" value="/" label="案場列表" />
            {authorize.user && ((authorize.user.user.features && authorize.user.user.features.Station) || authorize.user.user.level === 0) && 
              <StyledBottomNavigationAction component={Link} to="/station" value="/station" label="案場查詢" />}
            {authorize.user && ((authorize.user.user.features && authorize.user.user.features.Smart) || authorize.user.user.level === 0) && 
              <StyledBottomNavigationAction component={Link} to="/smart" value="/smart" label="智慧診斷" />}

            {authorize.user && authorize.user.user.level === 0 && 
              <StyledBottomNavigationAction component={Link} to="/fixrecord" value="/fixrecord" label="維運記錄" />}
            {authorize.user && authorize.user.user.level === 0 && 
              <StyledBottomNavigationAction component={Link} to="/stationfile" value="/stationfile" label="案場檔案資料" />}
          </BottomNavigation>            
          </Grid>
          <Grid item xs={2}>
          <BottomNavigation  component="div" showLabels value={navSelected} onChange={onNavChange} style={{ backgroundColor: 'rgba(245, 245, 245, 0.8)'}}>
            {/*
          <StyledBottomNavigationAction label="客戶管理" />
          <StyledBottomNavigationAction label="模組資料" />
          <StyledBottomNavigationAction label="檢測參數" />
          <StyledBottomNavigationAction label="維運紀錄" />
          */}
            <StyledBottomNavigationAction label={<Box>
              <Box display="inline" fontSize={8}>({authorize.user ? authorize.user.user.account: '??'})</Box><Box display="inline"> 登出</Box>
            </Box>} value="logout" />
          </BottomNavigation>
          </Grid>
        </Grid>
      </Box>
      <Box display="flex" width="100%" bgcolor="rgba(200, 200, 200, 0.5)" style={{ position: 'fixed', margin: "auto", bottom: 0, zIndex: -1 }}>
        <Box pl={10} flexGrow={1}>
          Copyright ©SolarBank 2020. All Right Reserved.
                    </Box>
        <Box pr={10}>
          Image credit: AwesomWallpaper
                    </Box>
      </Box>
    </>
  );
}

export default MenuBar;